/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetManagersViewModel } from './AssetManagersViewModel';
import {
    AssetManagersViewModelFromJSON,
    AssetManagersViewModelFromJSONTyped,
    AssetManagersViewModelToJSON,
} from './AssetManagersViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfAssetManagersViewModel
 */
export interface ResultOfAssetManagersViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfAssetManagersViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfAssetManagersViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfAssetManagersViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfAssetManagersViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfAssetManagersViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfAssetManagersViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfAssetManagersViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {AssetManagersViewModel}
     * @memberof ResultOfAssetManagersViewModel
     */
    data?: AssetManagersViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfAssetManagersViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfAssetManagersViewModel interface.
 */
export function instanceOfResultOfAssetManagersViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfAssetManagersViewModelFromJSON(json: any): ResultOfAssetManagersViewModel {
    return ResultOfAssetManagersViewModelFromJSONTyped(json, false);
}

export function ResultOfAssetManagersViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfAssetManagersViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : AssetManagersViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfAssetManagersViewModelToJSON(value?: ResultOfAssetManagersViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': AssetManagersViewModelToJSON(value.data),
        'Count': value.count,
    };
}

